// extracted by mini-css-extract-plugin
export default {"signup-form":"signup_signup-form__ORq3R","auth-form":"signup_auth-form__Sk5O2"};